<template>
  <div class="header" :class="{ 'header--night': $props.nightTheme }">
    <div class="title" :class="{ 'title--tagged': $props.tag }">
      <div class="back" v-if="$props.back" @click="$router.back()">
        <img v-if="$props.nightTheme" src="@/assets/icons/arrow_white.svg"
          alt="" class="back-image">
        <img v-else src="@/assets/icons/arrow.svg" alt="" class="back-image">
      </div>
      <div class="title-tag ccs-tag" v-if="$props.tag">
        {{$props.tag}}
      </div>
      {{$props.title}}
    </div>
    <!--<div class="info" v-if="$props.info">
      <img src="@/assets/images/user_tmp.svg" alt="" class="info-avatar">
      <img src="@/assets/icons/more.svg" alt="" class="info-more">
    </div>-->
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    title: {
      type: String,
      default: '...',
    },
    info: {
      type: Boolean,
      default: true,
    },
    nightTheme: {
      type: Boolean,
      default: false,
    },
    back: {
      type: Boolean,
      default: false,
    },
    tag: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  margin: 0 25px 0 33px;
  height: 80px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 30px;
    line-height: 38px;
    font-weight: bold;
    color: $primary;

    &--tagged {
      color: $surfaceDarker;
      font-size: 20px;

      > .ccs-tag {
        padding: 2px 5px 0 5px;
        height: 30px;
        color: $primary;
        background: #fff;
        font-size: 20px;
        font-weight: 900;
      }

    }

    .back {
      margin-right: 20px;
      height: 30px;
      width: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 5px;
      border: 1px solid #9FB1DF;

      &:hover {
        cursor: pointer;
      }

    }

  }

  .info {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    &-avatar {
      height: 31px;
      width: 31px;
      border-radius: 31px;
    }

    &-more {
      margin-left: 14px;
    }

  }

  &--night {

    .title {
      color: #fff;

      .back { border: 1px solid #fff; }

    }

  }

}
</style>
